const getCookies = () => {
  const pairs = document.cookie.split(';');
  const cookies = {};
  for (let i = 0; i < pairs.length; i++) {
    const pair = pairs[i].split('=');
    cookies[`${pair[0]}`.trim()] = pair.slice(1).join('=');
  }
  return cookies;
};

/**
 * 初始化开发工具
 */
function initLoginDevTool() {
  if (window.location.host === 'www.okcoin.jp') {
    return;
  }
  // eslint-disable-next-line no-underscore-dangle
  window._get_login_data = () => {
    const cookies = getCookies();
    const localStorages = { ...localStorage };
    const syncDataStr = JSON.stringify({
      cookies,
      localStorages,
    });
    console.log(`'${btoa(unescape(encodeURIComponent(syncDataStr)))}'`);
  };

  // eslint-disable-next-line no-underscore-dangle
  window._set_login_data = (syncDataStr) => {
    const { cookies, localStorages } = JSON.parse(
      decodeURIComponent(escape(atob(syncDataStr)))
    );
    Object.keys(cookies).forEach((key) => {
      const exp = new Date();
      exp.setTime(exp.getTime() + 7 * 24 * 60 * 60 * 1000);
      document.cookie = `${key}=${
        cookies[key]
      };expires=${exp.toGMTString()};path=/`;
    });
    Object.keys(localStorages).forEach((key) => {
      localStorage[key] = localStorages[key];
    });
    setTimeout(() => {
      window.location.reload();
    }, 1000);
    return 'success';
  };
}

// eslint-disable-next-line import/prefer-default-export
export { initLoginDevTool };
